import {
  Component,
  OnInit,
  inject,
  TemplateRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  UntypedFormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { marker as TRANSLATE_ME } from "@biesbjerg/ngx-translate-extract-marker";
import { CrudService } from "../../Services/crud.service";
import { LogedInUserService } from "../../Services/loged-in-user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DeleteConfirmationDialogComponent } from "../delete-confirmation-dialog/delete-confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";

import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ROLE } from "../../Utils/const";
import { data } from "jquery";
import { LoadingService } from "src/app/Services/loading.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  standalone: false,
})
export class DashboardComponent implements OnInit {
  @ViewChild("manageButton") myButton!: ElementRef<HTMLButtonElement>;

  heading = "Analytics Dashboard";
  subheading =
    "This is an example dashboard created using build-in elements and components.";
  icon = "pe-7s-plane icon-gradient bg-tempting-azure";
  buttonText = "+";
  data = [];
  projectDetails: {};
  totalUsersCount = 0;
  totalProjectsCount = 0;
  totalTooltipsCount = 0;
  totalWorkflowsCount = 0;
  totalFAQsCount = 0;
  totalUserGuidesCount = 0;
  ROLE = ROLE;
  showUserManage = false;
  showTranslatorManage = false;
  loading = false;
  isLoading = false;
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private router: Router,
    private dialog: MatDialog,
    private loadingService: LoadingService
  ) {
    this.isLoading = true;
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    this.showUserManagement();
    this.showTranslator();
    this.getProjectManagementData = this.getProjectManagementData.bind(this);
    this.getScreenCounts = this.getScreenCounts.bind(this);
    this.getTooltipsCount = this.getTooltipsCount.bind(this);
    this.getFAQsCount = this.getFAQsCount.bind(this);
    this.getUserGuidesCount = this.getUserGuidesCount.bind(this);
    this.getLanguageCount = this.getLanguageCount.bind(this);
    this.getUserCount = this.getUserCount.bind(this);
    this.isLoading = false;
  }

  ngOnInit() {
    this.isLoading = true;
    this.getProjectManagementData();
    this.getUserCount();
    this.isLoading = false;
  }

  showUserManagement() {
    let self = this;
    self.logedInUserService.get(function (logedInUser) {
      const isAdmin = logedInUser.roleId.some((id) => {
        return Object.values(self.ROLE[0])[0] === id;
      });

      self.showUserManage = isAdmin;
    });
  }

  showTranslator() {
    let self = this;
    self.logedInUserService.get(function (logedInUser) {
      // console.log("loggedin user", logedInUser);
      const isTranslator = logedInUser.roleId.some((id) => {
        return Object.values(self.ROLE[5])[0] === id;
      });

      self.showTranslatorManage = isTranslator;
    });
  }

  getProjectManagementData() {
    let self = this;

    self.logedInUserService.get(function (logedInUser) {
      self.crudService.get(
        null,
        async function (response) {
          if (response && response.length) {
            self.totalProjectsCount = response.length;

            // Create array of promises
            const enrichedProjects = await Promise.all(
              response.map(async (element) => {
                element.count = {
                  screens: 0,
                  tooltips: 0,
                  workflows: 0,
                  FAQs: 0,
                  userGuides: 0,
                  languages: self.getLanguageCount(element),
                };

                // Fetch version and attach to element
                const version = await self.fetchVersion(element);
                element.version = version; // You can modify this based on structure

                return element;
              })
            );

            self.data = enrichedProjects;

            self.getScreenCounts();
          } else {
            self.data = [];
          }
        },
        'projectManagements?filter={"where":{"companyId":"' +
          logedInUser.companyId +
          '"}}'
      );
    });
  }

  // Returns a Promise
  fetchVersion(project): Promise<any> {
    let self = this;
    return new Promise((resolve, reject) => {
      self.crudService.get(
        null,
        function (detailsResponse) {
          resolve(detailsResponse);
        },
        `Versions?filter={"where":{"projectManagementId":"${project.id}"}}`
      );
    });
  }

  getLanguageCount(project) {
    var count = 0;
    if (project.supportedLanguage && project.supportedLanguage.length) {
      project.supportedLanguage.forEach((element) => {
        if (element) count++;
      });
    }
    return count;
  }

  openScreenDetailView(projectId) {
    // this.router.navigate(["/page/project-detail", projectId]);
    this.router.navigate(["/page/project-detail", projectId], {
      fragment: "project",
    });
  }
  navigateToTranslation(pid, tabId) {
    this.router.navigate(["/page/translation", pid, tabId]);
  }

  openProjectDetailView(projectId) {
    this.router.navigate([
      "/page/project-management",
      projectId ? projectId : "new-project",
    ]);
  }

  getScreenCounts() {
    let self = this;
    self.logedInUserService.get(function (logedInUser) {
      self.data.forEach((element: any) => {
        if (element.supportedLanguage && element.supportedLanguage.length) {
          element.showTransButton = true;
          if (
            element.supportedLanguage.length < 2 &&
            element.supportedLanguage[0].id == element.primaryLanguage
          ) {
            element.showTransButton = false;
          }
        } else {
          element.showTransButton = false;
        }
        self.crudService.get(
          null,
          function (latestVersion) {
            self.crudService.get(
              null,
              function (response) {
                element.count.screens = response.length;
                response.forEach((pScreenManagement) => {
                  self.getTooltipsCount(
                    pScreenManagement.id,
                    element,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                  self.getWorkflowsCount(
                    pScreenManagement.id,
                    element,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                  self.getFAQsCount(
                    pScreenManagement.id,
                    element,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                  self.getUserGuidesCount(
                    pScreenManagement.id,
                    element,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                });
              },
              'screenManagements?filter={"where":{"companyId":"' +
                logedInUser.companyId +
                '", "projectId":"' +
                element.id +
                '"}}'
            );
          },
          "Versions/findOne?filter[order]=created DESC&filter[where][projectManagementId]=" +
            element.id
        );
      });
    });
    this.loading = false;
  }

  openUsageAnalytics(projectId) {
    this.router.navigate(["/page/usage-analytics", projectId]);
  }

  getUserCount() {
    let self = this;
    self.logedInUserService.get(function (logedInUser) {
      self.crudService.get(
        null,
        function (response) {
          if (response && response.length)
            self.totalUsersCount = response.length;
        },
        "userManagements?filter[where][companyId]" + logedInUser.companyId
      );
    });
  }

  openDeleteConfirmationDialog(project): void {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      panelClass: "custom-bg",
      data: {
        title: "Delete Project",
        paragraph: `${
          project.count.screens > 0 ||
          project.count.tooltips > 0 ||
          project.count.workflows > 0 ||
          project.count.FAQs > 0 ||
          project.count.userGuides > 0
            ? `This will delete ${
                project.count.screens
                  ? `${project.count.screens} ${
                      +project.count.screens == 1 ? "screen" : "screens"
                    }`
                  : ""
              } ${
                project.count.tooltips
                  ? `${project.count.tooltips} ${
                      +project.count.tooltips == 1 ? "tooltip" : "tooltips"
                    }`
                  : ""
              } ${
                project.count.workflows
                  ? `${project.count.workflows} ${
                      +project.count.workflows == 1 ? "workflow" : "workflows"
                    }`
                  : ""
              } ${
                project.count.FAQs
                  ? `${project.count.FAQs} ${
                      +project.count.FAQs == 1 ? "FAQ" : "FAQs"
                    }`
                  : ""
              } ${
                project.count.userGuides
                  ? `${project.count.userGuides} ${
                      +project.count.userGuides == 1
                        ? "user guide"
                        : "user guides"
                    }`
                  : ""
              }. `
            : ""
        }Are you sure you want to delete this project?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Project has been deleted successfully.",
                "Success"
              );
              this.getProjectManagementData();
            }
          },
          "projectManagements/" + project.id
        );
      }
    });
  }

  getTooltipsCount(screenManagementId, productObj, projectId, latestVersion) {
    let self = this;
    let query = `screenManagementId=${screenManagementId}&languageId=${productObj.primaryLanguage}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;
    // console.log("version LATEST", latestVersion);
    this.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.totalTooltipsCount += response.length;
          productObj.count.tooltips += response.length;
        }
      },
      "tooltips/getTooltipsForWebAndPlugin?" + query
    );
  }

  getFAQsCount(screenManagementId, productObj, projectId, latestVersion) {
    let self = this;
    let query = `screenManagementId=${screenManagementId}&languageId=${productObj.primaryLanguage}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;
    this.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.totalFAQsCount += response.length;
          productObj.count.FAQs += response.length;
        }
      },
      "faqs/getFaqsForWebAndPlugin?" + query
    );
  }

  getUserGuidesCount(screenManagementId, productObj, projectId, latestVersion) {
    let self = this;
    let query = `screenManagementId=${screenManagementId}&languageId=${productObj.primaryLanguage}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;

    this.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.totalUserGuidesCount += response.length;
          productObj.count.userGuides += response.length;
        }
      },
      "userGuides/getUserGuidesForWebAndPlugin?" + query
    );
  }

  getWorkflowsCount(screenManagementId, productObj, projectId, latestVersion) {
    let self = this;
    let query = `screenManagementId=${screenManagementId}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.totalWorkflowsCount += response.length;
          productObj.count.workflows += response.length;
        }
      },
      "workflows/getWorkflowsForWebAndPlugin?" + query
    );
  }

  openUserManagement() {
    this.router.navigate(["/page/user-management"]);
  }
  goToAuditLog(pmId: string) {
    this.loadingService.show(); // start loading

    this.router.navigate(["/page/auditlog", pmId], {
      fragment: "pendingPublish",
    });
  }
}
